//? Library Imports ------------------------------------------------------------>
import Image from "next/image";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import { Row, Col, Space, Checkbox, Typography } from "antd";
import { useState, useEffect, useCallback, useMemo } from "react";
import Cookies from "js-cookie";

//? Modules -------------------------------------------------------------------->
// import MediaQueryHook from "@/hooks/useMediaQuery/MediaQueryHook";
import StitchingIcon from "../../../../assets/images/ProductPage/Stitching Icon.svg";
// import SizeChartDrawer from "../SizeChart/SizeChartDrawer/SizeChartDrawer";
import { removeCommasAndConvertToNumber } from "../../../../functions/HelperFunctions/index";

const CustomStitching = dynamic(() =>
  import("./CustomStitching/CustomStitching")
);
const AddonOptions = dynamic(() =>
  import("../ProductDetailPanel/AddonOptions/AddonOptions")
);

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function StitchingModule({
  userAgent,
  ProductDetail,
  StitchingDetail,
  EnableStitching,
  setEnableStitching,
  DefaultStitching,
  setDefaultStitching,
  LineItemAddons,
  setLineItemAddons,
  setViewBagItemsState,
  isOutSideProductDetailComponent,
  SelectedVariant,
  pushedVariants,
  setPushedVariants,
  availableVariants,
  ProductQuantity,
  setProductQuantity,
  setSelectedVariant,
  productSoldout,
  setProductSoldout,
  selectedValueFromOptions,
  setSelectedValueFromOptions,
  handleOptionChange,
  viewBagItemsState,
  openDrawer,
  setOpenDrawer,
  showDrawer,
  addProduct,
  addToCartLoader,
  setaddToCartLoader,
  handleProductDiscountedPrice,
  handleProductOrignalPrice,
  // isSizeChartOpen,
  // setIsSizeChartOpen,
}) {
  //? Hooks ---------------------------------------------------------------------->
  // const { isMobile, isTablet } = MediaQueryHook();
  const { isMobile, isTablet, isDesktop } = userAgent;
  const defaultCurrency = Cookies.get("defaultCurrencyName");

  //? States --------------------------------------------------------------------->
  const [OtherTempelates, setOtherTempelates] = useState([]);

  // const defaultCurrency = useSelector(
  //   (state) => state?.multiLocation?.defaultCurrency
  // );

  //? Functions ------------------------------------------------------------------>
  const enableStitching = (e) => {
    if (!isOutSideProductDetailComponent) {
      setViewBagItemsState(false);
    }
    const checked = e.target.checked;

    if (checked) {
      setEnableStitching(true);

      const LineItemOptions = DefaultStitching?.map(
        ({ id: option, name: name }) => ({
          name,
          option,
        })
      );

      // console.log("LineItemOptions----->", LineItemOptions);
      setLineItemAddons(LineItemOptions);
      //   setSelectedStitchingOptions(DefaultStitching);
    } else {
      setLineItemAddons([]);
      //   setSelectedStitchingOptions([]);
      setEnableStitching(false);
    }
  };

  const calculateDefaultStitching = useCallback(() => {
    const StitchingAddons = ProductDetail?.add_on_templates?.find(
      (template) => template.type === "stitching"
    );
    // console.log("StitchingAddons----->", StitchingAddons);

    const FirstAddonOption = StitchingAddons?.add_ons[0]?.options.find(
      (option) => removeCommasAndConvertToNumber(option.discounted_price) > 0
    );
    // console.log("FirstAddonOption----->", FirstAddonOption);

    const defaultStitchingOption = [];
    defaultStitchingOption.push(FirstAddonOption);

    setDefaultStitching(defaultStitchingOption);
  }, [ProductDetail?.add_on_templates, setDefaultStitching]);

  const calculateStitching = useMemo(() => {
    const StitchingAddons = ProductDetail?.add_on_templates?.find(
      (template) => template.type === "stitching"
    );
    // console.log("StitchingAddons----->", StitchingAddons);

    let stitchingPrice = 0; // Variable to store the sum of stitching prices

    LineItemAddons?.forEach((lineItem) => {
      StitchingAddons?.add_ons[0]?.options?.forEach((option) => {
        if (lineItem.option === option.id) {
          stitchingPrice += removeCommasAndConvertToNumber(
            option.discounted_price
          );
        }
      });
    });

    return stitchingPrice;
  }, [LineItemAddons, ProductDetail?.add_on_templates]);

  const otherTempelates = useCallback(() => {
    setOtherTempelates(
      ProductDetail?.add_on_templates?.filter(
        (template) => template?.type === "others"
      )
    );
  }, [ProductDetail?.add_on_templates]);

  //? Life Cycles ---------------------------------------------------------------->
  useEffect(() => {
    otherTempelates();
    calculateDefaultStitching();
  }, [calculateDefaultStitching, otherTempelates]);

  // useEffect(() => {}, [EnableStitching]);

  // console.log("LineItemAddons", LineItemAddons);
  // console.log("EnableStitching", EnableStitching);
  // console.log("calculateStitching", calculateStitching);

  return (
    <Col span={24} className="StitchingOptions">
      <Row gutter={[20, 20]} className="margin0">
        <Col
          span={24}
          className={
            isMobile || isTablet
              ? "borderNone padding10 backgroundLight"
              : "border padding10 customStitching flexColumn"
          }
        >
          <Space
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Image src={StitchingIcon} alt="Stitching Icon" />
              <Text className="font16">Stitching Service</Text>
            </div>

            {/* {ProductDetail?.size_chart?.length ? (
              <SizeChartDrawer
                calculateStitching={calculateStitching.toLocaleString()}
                ProductDetail={ProductDetail}
                SizeChart={ProductDetail?.size_chart}
                SelectedVariant={SelectedVariant}
                setSelectedVariant={setSelectedVariant}
                availableVariants={availableVariants}
                ProductQuantity={ProductQuantity}
                setProductQuantity={setProductQuantity}
                viewBagItemsState={viewBagItemsState}
                setViewBagItemsState={setViewBagItemsState}
                userAgent={userAgent}
                LineItemAddons={LineItemAddons}
                setLineItemAddons={setLineItemAddons}
                openDrawer={openDrawer}
                setOpenDrawer={setOpenDrawer}
                showDrawersizechart={showDrawer}
                addProduct={addProduct}
                pushedVariants={pushedVariants}
                setPushedVariants={setPushedVariants}
                handleOptionChange={handleOptionChange}
                addToCartLoader={addToCartLoader}
                setaddToCartLoader={setaddToCartLoader}
                selectedValueFromOptions={selectedValueFromOptions}
                setSelectedValueFromOptions={setSelectedValueFromOptions}
                handleProductDiscountedPrice={handleProductDiscountedPrice}
                handleProductOrignalPrice={handleProductOrignalPrice}
                isSizeChartOpen={isSizeChartOpen}
                setIsSizeChartOpen={setIsSizeChartOpen}
              />
            ) : null} */}
          </Space>

          <Checkbox
            checked={EnableStitching}
            onChange={(e) => enableStitching(e)}
            className={
              EnableStitching
                ? "radio_container marginTop10 checkboxChecked width100"
                : "radio_container marginTop10 width100"
            }
          >
            <Row justify="space-between">
              <Col className={!isDesktop ? "font12" : ""}>
                Get Your Clothes Stitched
              </Col>

              {DefaultStitching?.length && calculateStitching < 1 ? (
                <Col flex="1 1 auto" className="flexEnd">
                  <Text
                    className={!isDesktop ? "font12Bold" : "font14Bold font600"}
                  >
                    +{defaultCurrency}&nbsp;
                    {DefaultStitching[0]?.original_price}
                  </Text>
                </Col>
              ) : (
                <Col flex="1 1 auto" className="flexEnd">
                  <Text
                    className={!isDesktop ? "font12Bold" : "font14Bold font600"}
                  >
                    +{defaultCurrency}&nbsp;
                    {calculateStitching.toLocaleString()}
                  </Text>
                </Col>
              )}
            </Row>
          </Checkbox>
        </Col>

        {EnableStitching ? (
          ProductDetail?.add_on_templates?.length ? (
            <Col
              span={24}
              style={{ marginTop: isDesktop ? "-20px" : "0px" }}
              className={!isDesktop ? "padding0" : "padding0"}
            >
              {ProductDetail?.add_on_templates?.map((template, index) => {
                return (
                  <Col span={24} key={index} className="padding0">
                    {template?.type === "stitching" ? (
                      <CustomStitching
                        template={template}
                        userAgent={userAgent}
                        ProductDetail={ProductDetail}
                        LineItemAddons={LineItemAddons}
                        StitchingDetail={StitchingDetail}
                        EnableStitching={EnableStitching}
                        setLineItemAddons={setLineItemAddons}
                        setViewBagItemsState={setViewBagItemsState}
                        isOutSideProductDetailComponent={
                          isOutSideProductDetailComponent
                        }
                      />
                    ) : null}
                  </Col>
                );
              })}
            </Col>
          ) : null
        ) : (
          OtherTempelates?.map((template, index) => {
            return index < 1 ? (
              <Col
                style={{ display: EnableStitching && "none" }}
                key={index}
                span={24}
                className="padding0"
              >
                <AddonOptions
                  template={template}
                  userAgent={userAgent}
                  ProductDetail={ProductDetail}
                  LineItemAddons={LineItemAddons}
                  setLineItemAddons={setLineItemAddons}
                  setViewBagItemsState={setViewBagItemsState}
                />
              </Col>
            ) : null;
          })
        )}
      </Row>
    </Col>
  );
}
